<template>
  <q-dialog v-model="visible" persistent>
    <q-card style="max-width: 800px !important; width: 800px !important">
      <q-toolbar class="auto-height horizontal-line">
        <q-toolbar-title class="q-pa-sm">リッチメニュー選択</q-toolbar-title>
        <q-btn flat round dense icon="close" @click="onCancel" />
      </q-toolbar>
      <q-card-section class="q-pa-md horizontal-line">
        <div class="text-subtitle2 text-bold q-my-sm q-ml-sm">リッチメニュー</div>
        <div class="text-subtitle2 q-my-sm q-ml-sm">
          表示条件設定を「なし」にした後に表示するリッチメニューを１つ選択してください。
        </div>
        <q-input outlined dense v-model="search" label="リッチメニュー名で検索..." class="q-mt-md q-mb-sm">
          <template v-slot:append>
            <q-icon name="search" color="text-prey-3" />
          </template>
        </q-input>
        <div class="row horizontal-line">
          <div class="text-caption col q-pl-sm">リッチメニュー名</div>
          <div class="text-caption col-2">作成日</div>
          <div class="text-caption col-2">作成者</div>
        </div>
        <template v-for="(menu, index) in richMenusFilter" :key="index">
          <div
            class="row q-mt-sm q-py-sm cursor-pointer"
            :class="selectedMenu._id === menu._id ? 'selected-menu' : ''"
            @click="onSelectMenu(menu)"
          >
            <div class="text-subtitle2 text-bold col q-pl-sm">{{ menu.name }}</div>
            <div class="text-caption col-2">{{ menu.created_at }}</div>
            <div class="text-caption col-2">{{ menu.creator_name }}</div>
          </div>
        </template>
        <q-separator class="q-mt-sm" />
        <div class="row no-wrap items-center q-mt-md">
          <q-space />
          <div class="q-gutter-sm">
            <q-btn no-caps class="btn-cancel" @click="onCancel">{{ $t('cancel') }} </q-btn>
            <q-btn no-caps class="btn-save" @click="onSubmit" :disable="!selectedMenu._id"> {{ $t('save') }} </q-btn>
          </div>
        </div>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script lang="ts">
import { mixins, Options } from 'vue-class-component'
import BaseFormDialogMixin from '@/components/common/mixins/BaseFormDialogMixin.vue'
import { Prop } from 'vue-property-decorator'
import { maska } from 'maska'
import { IRichMenu } from '@/utils/types'

@Options({
  components: {},
  directives: { maska },
  emits: ['update:modelValue', 'update:defaultRichMenu', 'update:closeModal'],
})
export default class DefaultRichMenuModal extends mixins(BaseFormDialogMixin) {
  @Prop()
  richMenus!: IRichMenu[]

  selectedMenu: IRichMenu = {}
  search = ''

  get richMenusFilter() {
    if (this.search) {
      return this.richMenus.filter((item) => item.name?.toLowerCase().includes(this.search.toLowerCase()))
    }
    return this.richMenus
  }

  onSelectMenu(menu: IRichMenu) {
    this.selectedMenu = menu
  }

  onSubmit() {
    this.$emit('update:defaultRichMenu', this.selectedMenu)
  }
}
</script>

<style scoped lang="scss">
.selected-menu {
  background-color: #63a9e51a;
}
</style>
